import React, { useEffect } from 'react';
import { Link } from 'react-scroll';
import './EventSliderTile.scss';
import { useHistory } from 'react-router-dom';

const EventSliderTile = ({
    id,
    title,
    imgUri,
    tileSize,
    transformSize,
    onHoverFunction,
    active
}) => {
    const history = useHistory();
    const viewProject = () => {
        console.log('abc');
        history.push(`/projects?_id=${id}`);
    };

    return (
        <div className={`EventSliderTile ${active ? 'active' : ''}`}
            id={`${imgUri}tile`}
            style={{
                width: `${tileSize}px`,
                height: `${tileSize}px`,
                transform: `translateY(${transformSize}px) scale(${active ? 1 : 0.8})`,
                transition: '1s',
            }}
            onMouseOver={() => onHoverFunction(true)}
            onMouseLeave={() => onHoverFunction(false)}
        >
            <div className="event-tile-title">{title}</div>
            <div onClick={viewProject}>
                <div className="event-tile-see-more-btn">View Event</div>
            </div>
            <div className="event-tile-img-filter"></div>
            <div className="event-tile-img-container">
                <img src={imgUri} alt={title} className="event-tile-img" />
            </div>
        </div>
    );
};

export default EventSliderTile;
